import type { WorkItemMinimalInfoService } from '../../preload/setup';

export type WorkItemMinimalInfo = {
  workflow_mode?: boolean;
  need_node_details?: boolean;
};

export type WorkItemMinimalInfoParams = {
  project_simple_name: string;
  work_item_api_name: string;
  work_item_id: number;
  node_key?: string;
};

export const IWorkItemMinimalInfoService = Symbol('IWorkItemMinimalInfoService');
export type IWorkItemMinimalInfoService = WorkItemMinimalInfoService;
